import { Store } from "../reducers";
import { CheckoutTarif } from "../../types/checkout";

export const selectCheckoutTariffs = (state: Store): CheckoutTarif[] | null =>
  state.checkout.tariffs.data;
export const selectCheckoutTariffsIsLoading = (state: Store): boolean =>
  state.checkout.tariffs.isLoading;
export const selectCheckoutTariffsError = (state: Store): string =>
  state.checkout.tariffs.error;
